<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :classDialog="'createDialog'"
      :offsetTop="''"
      :openDialog="isOpen"
      :widthDialog="'900px'"
      @closeDialog="$emit('closed')"
      @closed="$emit('closed')"
    >
      <template #body>
        <VuePerfectScrollbar :settings="settings" class="scroll-area">

          <div class="body">
            <div class="group__info margin-top-10 padding-bottom-10">
              <h3>THÔNG TIN XÁC THỰC VĂN BẢN</h3>
              <br>
              <div class="item flex-row flex__left margin-bottom-10">
                <h4>Trích yếu: </h4>
                <div class="label font-size__small txt-right">
                  &emsp;{{ quote }}
                </div>
              </div>
              <div v-if="valid==='CHUA_CHINH_SUA'" class="item flex-row flex__left margin-bottom-10">
                <h4>Hiệu lực văn bản: </h4>
                <div class="label font-size__small txt-right">
                  &emsp;
                  <i class="el-icon-success color__green"></i>
                  &emsp;Nội dung văn bản nguyên vẹn
                </div>
              </div>
              <div v-if="valid==='DA_CHINH_SUA'" class="item flex-row flex__left margin-bottom-10">
                <h4>Hiệu lực văn bản: </h4>
                &emsp;
                <div class="label font-size__small txt-right">
                  <i class="el-icon-warning color__red"></i>
                  Nội dung văn bản đã bị thay đổi
                </div>
              </div>
              <div v-if="valid==='KHONG_TIM_THAY'" class="item flex-row flex__left margin-bottom-10">
                <h4>Hiệu lực văn bản: </h4>
                &emsp;
                <div class="label font-size__small  ">
                  <i class="el-icon-warning color__yellow"></i>
                  Không tìm thấy chữ ký số
                </div>
              </div>
              <br>
              <div class="item flex-row flex__left margin-bottom-10">
                <h3>Thông tin chữ ký số: </h3>
              </div>
            </div>

            <div v-for="(item, index) in signatureInfoList"
                 :key="item.name"
                 class="group__info margin-top-10 padding-bottom-10"
            >
              <div class="title font-size__medium">{{ index + 1 }}. Ký bởi: {{ item.signer }}</div>
              <div class="ctn">
                <div class="list-info width__100">
                  <div class="item flex-row flex__left margin-bottom-10">
                    <div class="label font-size__small txt-right">
                      ngày kí
                    </div>
                    <div class="content width__100 has-border__bottom">
                      {{
                        item.signOn
                      }}
                    </div>
                  </div>
                  <div
                    class="item flex-row flex__left margin-bottom-10"
                  >
                    <div class="label font-size__small txt-right">
                      Thời gian hiệu lực CTS
                    </div>
                    <div class="content width__100 has-border__bottom">
                      {{ item.durationValidCertificate }}
                    </div>
                  </div>
                  <div
                    class="item flex-row flex__left margin-bottom-10"
                  >
                    <div class="label font-size__small txt-right">
                    </div>
                    <div v-if="item.signOnValidTime" class="content width__100 has-border__bottom">
                      <div>
                        <i class="el-icon-success color__green"></i>
                        &emsp; Chữ ký còn hiệu lực tại thời điểm ký
                      </div>
                    </div>
                    <div v-else class="content width__100 has-border__bottom">
                      <div>
                        <i class="el-icon-warning color__red"></i>
                        &emsp; Chữ ký không còn hiệu lực tại thời điểm ký
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>

      </template>
    </dialogTemplate>
  </div>
</template>

<script>
import dateFormatter from "../../../src/filters/dateFormatter";
import handleRequestErrorMixin from "../../../src/views/handleRequestErrorMixin";
import signatureInfoService from "../../services/signatureInfoService";

export default {
  mixins: [handleRequestErrorMixin],
  name: "signature-info-list-dialog",
  props: ["isOpen", "docId", "quote", "attachmentId"],
  filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../../views/common/custom-dialog.vue"),
    selectDepartmentDialog: () =>
      import("../../views/common/commonSelectDepartmentDialog"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },
  computed: {},
  data() {
    return {
      isEnableSelectDepartmentDialog: false,
      isOpenDialogCreate: true,
      settings: {maxScrollbarLength: 750},
      signatureInfoList: [],
      errorMessageFilter: [],
      valid: 'KHONG_TIM_THAY'
    };
  },

  created() {
    this.loadSignatureInfo()
  },

  watch: {},
  methods: {
    loadSignatureInfo() {
      if (this.attachmentId) {
        signatureInfoService.getSignatureInfoByAttachmentId(this.attachmentId).then(
          response => {
            this.signatureInfoList = response.data
            if (response.data.length) {
              response.data[0].isModified ? this.valid = 'DA_CHINH_SUA' : this.valid = 'CHUA_CHINH_SUA'
            }
            // else {
            //   this.valid = 'KHONG_TIM_THAY'
            // }
          }
        )
      } else {
        signatureInfoService.getSignatureInfo(this.docId).then(response => {
          this.signatureInfoList = response.data
          if (response.data.length) {
            response.data[0].isModified ? this.valid = 'DA_CHINH_SUA' : this.valid = 'CHUA_CHINH_SUA'
          }
          // else {
          //
          // }
        })
      }

    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/signatureInfo/signatureInfoListDialog.vue